(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/game-package/assets/react/components/game-card/game-card.js') >= 0) return;  svs.modules.push('/modules/game-package/assets/react/components/game-card/game-card.js');

'use strict';

const Brand = svs.ui.ReactBrand;
const {
  useSelector
} = ReactRedux;
const {
  isToday,
  parseISO
} = dateFns;
const {
  getLocalizedWeekday
} = svs.utils.date;
const {
  getBrandingClass,
  isEurojackpot,
  isLotto
} = svs.numbergames.productMapping;
const {
  useCampaign
} = svs.gamePackage.hooks;
const {
  ExtraGameInfo,
  GameCardBody,
  GameCardBodySelfService
} = svs.gamePackage.components;
const {
  Card,
  CardHeader,
  CardBody,
  CardExpandableBody
} = svs.ui.ReactCard;
const {
  RibbonCorner
} = svs.ui.ReactRibbon;
const {
  isSelfService
} = svs.core.config.data.svsconfig;
const {
  selectGame,
  selectDraw,
  selectJackpot
} = svs.gamePackage.redux.selectors;
const GameCard = _ref => {
  let {
    uniqueId,
    isExpandable = false,
    packageIsClosed
  } = _ref;
  const game = useSelector(state => selectGame(state, uniqueId));
  const {
    productId,
    productItsId,
    boards,
    hasJoker,
    hasLotto2,
    price
  } = game;
  const draw = useSelector(state => selectDraw(state, productItsId));
  const {
    jackpotText
  } = useSelector(state => selectJackpot(state, productItsId));
  const campaignInfo = useCampaign({
    game,
    draw
  });
  const givesCampaingChances = Boolean(campaignInfo === null || campaignInfo === void 0 ? void 0 : campaignInfo.numberOfChances);
  const expandable = isExpandable || isLotto(productId) || givesCampaingChances;
  return React.createElement("div", {
    className: "gp-game-card"
  }, React.createElement(Card, {
    align: "center",
    expandable: expandable,
    className: packageIsClosed ? 'card-faded' : ''
  }, React.createElement(CardHeader, {
    className: "branding-".concat(getBrandingClass(productId) || 'default')
  }, givesCampaingChances && React.createElement(RibbonCorner, null, "Kampanj"), React.createElement("div", null, React.createElement(Brand, {
    brand: productId.toLowerCase(),
    emblem: true,
    size: isEurojackpot(productId) ? 100 : 150
  }), React.createElement("p", {
    className: "card-header-jackpot"
  }, jackpotText))), React.createElement(CardExpandableBody, null, expandable && isSelfService && React.createElement(GameCardBodySelfService, {
    game: game,
    draw: draw,
    campaignInfo: campaignInfo
  }), expandable && !isSelfService && React.createElement(GameCardBody, {
    game: game,
    draw: draw,
    campaignInfo: campaignInfo
  })), React.createElement(CardBody, null, React.createElement("p", {
    className: "card-body-header"
  }, packageIsClosed || !draw ? 'Stängt för spel' : "".concat(getLocalizedWeekday(draw.regCloseTime, true, !isToday(parseISO(draw.regCloseTime))))), React.createElement("p", {
    className: "card-boards f-content"
  }, boards.length, " rad", boards.length > 1 && 'er'), React.createElement(ExtraGameInfo, {
    price: price,
    productId: productId,
    hasJoker: hasJoker,
    hasLotto2: hasLotto2
  }))));
};
svs.gamePackage.components.GameCard = GameCard;

 })(window);